import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { ShieldFillExclamation, ShieldFillCheck, ShieldFillMinus, Calendar2Check, Calculator, Clipboard2Data } from "react-bootstrap-icons";
import "./Dashboard.css";

export default function Dashboard({ infracciones = [] }) {
    const total = infracciones.length;
    const totalUMAs = infracciones.reduce((sum, inf) => sum + (parseFloat(inf.cantidadUMAs) || 0), 0);

    const alta = infracciones.filter(i => i.incidencia === "Alta").length;
    const media = infracciones.filter(i => i.incidencia === "Media").length;
    const baja = infracciones.filter(i => i.incidencia === "Baja").length;

    // Obtener fecha de hoy en huso horario local (YYYY-MM-DD)
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const localToday = new Date(today.getTime() - (offset * 60 * 1000));
    const hoyStr = localToday.toISOString().split("T")[0];
    
    const hoy = infracciones.filter(i => {
        if (!i.fecha) return false;
        const parts = i.fecha.split("T");
        return parts[0] === hoyStr;
    }).length;

    // Calcular porcentajes
    const pctAlta = total > 0 ? Math.round((alta / total) * 100) : 0;
    const pctMedia = total > 0 ? Math.round((media / total) * 100) : 0;
    const pctBaja = total > 0 ? Math.round((baja / total) * 100) : 0;

    // SVG Circular Progress Helper
    const CircleProgress = ({ percentage, color, icon: Icon, label, count }) => {
        const radius = 35;
        const circumference = 2 * Math.PI * radius;
        const strokeDashoffset = circumference - (percentage / 100) * circumference;

        return (
            <div className="db_circle-card">
                <div className="db_circle-container">
                    <svg className="db_svg-circle" width="90" height="90">
                        <circle
                            className="db_circle-bg"
                            cx="45"
                            cy="45"
                            r={radius}
                        />
                        <circle
                            className="db_circle-bar"
                            cx="45"
                            cy="45"
                            r={radius}
                            style={{
                                stroke: color,
                                strokeDasharray: circumference,
                                strokeDashoffset: strokeDashoffset
                            }}
                        />
                    </svg>
                    <div className="db_circle-icon-overlay">
                        <Icon style={{ color }} size={22} />
                    </div>
                </div>
                <div className="db_circle-info">
                    <h5 className="db_circle-number">{percentage}%</h5>
                    <span className="db_circle-label">{label} ({count})</span>
                </div>
            </div>
        );
    };

    return (
        <div className="db_dashboard-wrapper">
            <h3 className="db_dashboard-title">Panel de Control & Estadísticas</h3>
            <Row className="g-4 mb-4">
                {/* Card 1: Total */}
                <Col xs={12} sm={6} md={3}>
                    <Card className="db_stat-card db_card-blue">
                        <Card.Body className="db_card-body">
                            <div className="db_card-header-icon">
                                <Clipboard2Data size={28} />
                            </div>
                            <div className="db_card-content">
                                <span className="db_card-label">Total Infracciones</span>
                                <h2 className="db_card-value">{total}</h2>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Card 2: Monto UMA */}
                <Col xs={12} sm={6} md={3}>
                    <Card className="db_stat-card db_card-purple">
                        <Card.Body className="db_card-body">
                            <div className="db_card-header-icon">
                                <Calculator size={28} />
                            </div>
                            <div className="db_card-content">
                                <span className="db_card-label">Monto Total (UMAs)</span>
                                <h2 className="db_card-value">{totalUMAs.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h2>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Card 3: Hoy */}
                <Col xs={12} sm={6} md={3}>
                    <Card className="db_stat-card db_card-green">
                        <Card.Body className="db_card-body">
                            <div className="db_card-header-icon">
                                <Calendar2Check size={28} />
                            </div>
                            <div className="db_card-content">
                                <span className="db_card-label">Registradas Hoy</span>
                                <h2 className="db_card-value">{hoy}</h2>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Card 4: Promedio de Severidad */}
                <Col xs={12} sm={6} md={3}>
                    <Card className="db_stat-card db_card-orange">
                        <Card.Body className="db_card-body">
                            <div className="db_card-header-icon">
                                <ShieldFillExclamation size={28} />
                            </div>
                            <div className="db_card-content">
                                <span className="db_card-label">Incidencias Altas</span>
                                <h2 className="db_card-value">{alta}</h2>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Circular Charts Section */}
            <Card className="db_charts-container mb-4">
                <Card.Body>
                    <h5 className="db_charts-title mb-4">Distribución por Severidad de Incidencia</h5>
                    <div className="db_circles-flex">
                        <CircleProgress
                            percentage={pctBaja}
                            color="#198754"
                            icon={ShieldFillCheck}
                            label="Incidencia Baja"
                            count={baja}
                        />
                        <CircleProgress
                            percentage={pctMedia}
                            color="#fd7e14"
                            icon={ShieldFillMinus}
                            label="Incidencia Media"
                            count={media}
                        />
                        <CircleProgress
                            percentage={pctAlta}
                            color="#dc3545"
                            icon={ShieldFillExclamation}
                            label="Incidencia Alta"
                            count={alta}
                        />
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
}
